var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0007 4.3335C17.0458 4.3335 12.5683 4.3335 11.2635 7.14839C11.1514 7.39035 11.0568 7.64168 10.9806 7.90004C10.0942 10.9056 13.2602 14.3892 19.5923 21.3564L23.834 26.0002H28.1673L32.409 21.3564C38.7411 14.3892 41.9071 10.9056 41.0207 7.90004C40.9445 7.64168 40.8499 7.39035 40.7378 7.14839C39.433 4.3335 34.9555 4.3335 26.0007 4.3335Z",
    fill: "#007f6d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.2635 44.8518C12.5683 47.6667 17.0458 47.6667 26.0007 47.6667C34.9555 47.6667 39.433 47.6667 40.7378 44.8518C40.8499 44.6098 40.9445 44.3585 41.0207 44.1001C41.9071 41.0945 38.7411 37.6109 32.409 30.6437L28.1673 26H23.834L19.5923 30.6437C13.2602 37.6109 10.0942 41.0945 10.9806 44.1001C11.0568 44.3585 11.1514 44.6098 11.2635 44.8518Z",
    fill: "#007f6d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadline);
export default __webpack_public_path__ + "static/media/deadline.cbdc483312a765579468a17c7d3ecd1d.svg";
export { ForwardRef as ReactComponent };